export default __webpack_public_path__ + "static/media/6 raw.0352083c.mp3";